import { render, staticRenderFns } from "./preferences-sheet.vue?vue&type=template&id=f8559dbc&scoped=true"
import script from "./preferences-sheet.vue?vue&type=script&lang=js"
export * from "./preferences-sheet.vue?vue&type=script&lang=js"
import style0 from "./preferences-sheet.vue?vue&type=style&index=0&id=f8559dbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8559dbc",
  null
  
)

export default component.exports